import styled from 'styled-components'
import {MedicalReportTextArea} from '../medical-report-text-area/MedicalReportTextArea'

export const StyledMedicalReportTextArea = styled(MedicalReportTextArea)`
    min-height: unset;
`
